import CanonicalExercise from '@/models/CanonicalExercise'
import api from '@/services/api'
import { each, find } from 'lodash'

export default {
  namespaced: true,
  state: {
    list: [],
    listMeta: {
      current_page: 0,
      last_page: 1,
      to: 1,
    },
    selected: null,
    filter: {
      search: null,
    },
  },

  mutations: {
    setList(state, canonicalExercises) {
      each(canonicalExercises, (canonicalExercise) => {
        const exist = find(state.list, { id: canonicalExercise.id })
        if (!exist) {
          state.list.push(new CanonicalExercise(canonicalExercise))
        }
      })
    },

    setListMeta(state, meta) {
      state.listMeta = meta
    },

    clearList(state) {
      state.list = []
    },

    setSelected(state, canonicalExercise) {
      state.selected = canonicalExercise
    },

    setFilter(state, filter) {
      state.filter = { ...state.filter, ...filter }
    },
  },

  getters: {
    list(state) {
      return state.list
    },

    hasList(state) {
      return state.list.length > 0
    },

    meta(state) {
      return state.listMeta
    },

    selected(state) {
      return state.selected
    },
  },

  actions: {
    async getCanonicalExercises({ commit }, params = {}) {
      const { page = 1, search = null, limit = 50 } = params

      const query = CanonicalExercise.page(page).orderBy('name')

      if (search) {
        query.where('search', search)
      }

      const res = await query.params({ limit }).get()

      commit('setList', res.data)
      commit('setListMeta', res.meta)

      return res
    },

    async getCanonicalExercise({ commit }, id) {
      // The API's show endpoint already eager-loads exercises + their trainer,
      // so no client-side include is needed (and an unexpected include would be
      // rejected by the backend query builder).
      const res = await CanonicalExercise.find(id)

      commit('setSelected', res.data || res)

      return res
    },

    async saveCanonicalExercise(context, params) {
      return new CanonicalExercise(params).save()
    },

    async deleteCanonicalExercise(context, id) {
      return new CanonicalExercise({ id }).delete()
    },

    async reassignExercises(context, { id, exerciseIds }) {
      const { data } = await api.post(`canonical-exercises/${id}/reassign`, {
        exercise_ids: exerciseIds,
      })

      return data
    },

    async getSimilarCanonicalExercises(context, params = {}) {
      const { data } = await api.get('canonical-exercises/similar', {
        params: { threshold: params.threshold },
      })

      return data.data
    },

    async mergeCanonicalExercises(context, { targetId, sourceId }) {
      const { data } = await api.post(`canonical-exercises/${targetId}/merge`, {
        source_id: sourceId,
      })

      return data
    },
  },
}
